import tokenManager from 'managers/tokenManager';
import loginManager from 'managers/loginManager';
import logoutManager from 'managers/logoutManager';
import sessionManager from 'managers/sessionManager';
import profileManager from 'managers/profileManager';

export default { tokenManager, loginManager, logoutManager, sessionManager, profileManager };
